export default "<p>\n  input-currency works!\n</p>\n";